import { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
import { Typography } from '@mui/material';
import { useAppDispatch } from '../../store/store';
import { deleteIntegrationDevice } from '../../store/thunk/deviceIntegration';
interface Props {
    open: boolean;
    handleClose: () => void;
    deleteIntegration: { pk: string; sk: string } | null
}

export default function DeleteIntegration({ open, handleClose, deleteIntegration }: Props) {

    const [loader, setLoader] = useState(false);
    const dispatch = useAppDispatch();
    const handleDelete = () => {
        if (!deleteIntegration) return;
        setLoader(true)
        dispatch(deleteIntegrationDevice(deleteIntegration)).finally(() => {
            setLoader(false);
            handleClose();
        });
    }

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle sx={{ mb: 0 }} style={{ cursor: 'move' }} id="draggable-dialog-title">
                    Delete device integration

                </DialogTitle>
                <DialogContent>

                    <DialogContentText>
                        Are you sure you want to delete this integration?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' onClick={handleClose}>
                        Cancel
                    </Button>
                    <LoadingButton loading={loader} color={"error"} variant='contained' onClick={() => handleDelete()}>
                        Delete
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </div >
    );
}
